import { JsonValueSchema } from 'notable-common';
import { z } from 'zod';
import { FlowRunBlockOutputStatus } from './blockOutputStatus.js';
import { FlowBlockState } from './blockState.js';
import { FlowRunState } from './flowRunState.js';
import { FlowRunType } from './runType.js';
import { FlowKind } from '../flow/enums.js';
import { FlowPricingMode } from '../flow/pricingMode.js';
import { FlowBlockUnionSchema } from '../flowDefinition/blocks/union.js';
import { FlowDefinitionState } from '../flowDefinition/flowDefinition.js';
/** Timestamps cross the wire as ISO strings, not the `Date` the database column holds. */
const IsoDateTimeResponseSchema = z.iso.datetime({ offset: true });
export const FlowRunBlockResponseSchema = z.object({
    id: z.uuid(),
    created: IsoDateTimeResponseSchema,
    updated: IsoDateTimeResponseSchema,
    flowRunId: z.uuid(),
    blockId: z.string(),
    blockVersion: z.string().nullable(),
    block: FlowBlockUnionSchema,
    state: z.enum(FlowBlockState),
    startedAt: IsoDateTimeResponseSchema.nullable(),
    endedAt: IsoDateTimeResponseSchema.nullable(),
    durationMillis: z.number().nullable(),
    dependsOnBlockIds: z.array(z.string()),
    error: JsonValueSchema.optional(),
    data: JsonValueSchema.optional(),
    metadata: JsonValueSchema.optional(),
    dataSizeBytes: z.number().int().nonnegative().nullable(),
    outputStatus: z.enum(FlowRunBlockOutputStatus).optional(),
});
export const FlowRunWithBlockShellsResponseSchema = z.object({
    id: z.uuid(),
    created: IsoDateTimeResponseSchema,
    updated: IsoDateTimeResponseSchema,
    flowDefinitionId: z.uuid(),
    organizationId: z.uuid(),
    entityId: z.string().nullable(),
    entityType: z.string().nullable(),
    startedById: z.uuid().nullable(),
    practiceId: z.string().nullable(),
    state: z.enum(FlowRunState),
    error: z.string().nullable(),
    parentId: z.uuid().nullable(),
    parentBlockId: z.string().nullable(),
    snapshotId: z.uuid().nullable(),
    flowDefinitionState: z.enum(FlowDefinitionState).nullable(),
    type: z.enum(FlowRunType),
    groupId: z.string().nullable(),
    startAttempts: z.number().int().nullable(),
    lastStartAttemptError: z.string().nullable(),
    testCaseId: z.uuid().nullable().optional(),
    startDataId: z.uuid().nullable().optional(),
    startedAt: IsoDateTimeResponseSchema.nullable(),
    endedAt: IsoDateTimeResponseSchema.nullable(),
    reRunFromRunId: z.uuid().nullable(),
    priority: z.number().nullable(),
    fleetId: z.uuid().nullable(),
    claimedBy: z.string().nullable(),
    claimedAt: IsoDateTimeResponseSchema.nullable(),
    archivedAt: IsoDateTimeResponseSchema.nullable(),
    blockDataArchivalGsPath: z.string().nullable(),
    flowId: z.uuid(),
    agentId: z.uuid().nullable(),
    flowKind: z.enum(FlowKind),
    pricingMode: z.enum(FlowPricingMode).nullable(),
    data: z.object({
        blocks: z.record(z.string(), FlowRunBlockResponseSchema),
    }),
});
export const GetFlowRunResponseSchema = z.object({
    flowRun: FlowRunWithBlockShellsResponseSchema,
});
export const GetFlowRunBlockResponseSchema = z.object({
    flowRunBlock: FlowRunBlockResponseSchema,
});
//# sourceMappingURL=response.js.map